"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.topPickFactory = topPickFactory;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _language = require("../utils/language.utils");
/**
 * toppick factory
 * @param {Object} topPicks
 * @param {String} language
 * @returns {Object}
 */
function topPickFactory(topPicks, language) {
  return {
    id: (0, _get2["default"])(topPicks, 'id', ''),
    categories: (0, _language.translate2keysLabel)(topPicks, 'categories', language),
    description: (0, _language.translate2keysLabel)(topPicks, 'description', language),
    distance: (0, _language.translate2keysLabel)(topPicks, 'distance', language),
    subcategories: (0, _language.translate2keysLabel)(topPicks, 'subcategories', language),
    category_icon: (0, _get2["default"])(topPicks, 'categoryIconLinkAlm')
  };
}